import React, { useState } from 'react';
import useStyles from './styles';
import clsx from 'clsx';

export default props => {
  const { accept, onFiles, getFilesFromEvent } = props;
  const classes = useStyles();

  const [inError, setError] = useState(false);

  const onFilesSelected = e => {
    const files = getFilesFromEvent(e);
    onFiles(files);
  };

  const onDragEnter = e => {
    const files = getFilesFromEvent(e);
    const hasError = (files || []).findIndex(file => !accept.includes(file.type)) !== -1;
    setError(hasError);
  };

  const resetError = () => {
    setError(false);
  };

  return (
    <label
      className={clsx(classes.root, inError && classes.inError)}
      onDragEnter={onDragEnter}
      onDrop={resetError}
      onDragLeave={resetError}>
      Drop Files Here or Click to Select
      <input accept={accept} multiple onChange={onFilesSelected} style={{ display: 'none' }} type="file" />
    </label>
  );
};
